export default __webpack_public_path__ + "media/titles/title_1_locale_sv-b25b0c80.png";